import { createRouter, createWebHistory } from '@ionic/vue-router';
import HomePage from '../views/HomePage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/donar',
    name: 'Donar',
    component: () => import('../views/HomePage.vue'),
    meta: { scrollTo: '#donar' }
  },
  {
    path: '/voluntariado',
    name: 'Voluntariado',
    component: () => import('../views/HomePage.vue'),
    meta: { scrollTo: '#voluntariado' }
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
